import { createFeatureSelector } from '@ngrx/store';
import { Ticket } from 'src/app/models/ticket/ticket.model';
import * as fromRoot from '.';
import * as fromActions from '../actions';

// State for this feature (Tickets)
export interface TicketState {
  entities: { [id: string]: Ticket };
  selectedTicketId: string;
  totalOpenTickets: number; // TODO: Delete and use ticket Stats/aggregates
  totalTickets: number;
  loaded: boolean;
  loading: boolean;
  error: string;
  currentPage: number;
  pageSize: number;
}

export const initialState: TicketState = {
  entities: {},
  selectedTicketId: null,
  totalOpenTickets: 0, // TODO: Delete and use ticket Stats/aggregates
  totalTickets: 0,
  loaded: false,
  loading: false,
  error: null,
  currentPage: 1,
  pageSize: 20,
};

export interface State extends fromRoot.State {
  tickets: TicketState;
}

// Selector functions
export const getTicketFeatureState =
  createFeatureSelector<TicketState>('tickets');

export function reducer(
  state: TicketState,
  action: fromActions.TicketsAction,
): TicketState {
  state = state ?? initialState;

  switch (action.type) {
    case fromActions.LOAD_TICKETS: {
      return {
        ...state,
        loading: true,
      };
    }

    case fromActions.LOAD_TICKETS_SUCCESS: {
      const { data, total } = action?.payload ?? { data: [], total: 0 };

      const entities =
        data.length > 0
          ? data.reduce(
              (acc: { [id: string]: Ticket }, ticket) => ({
                ...acc,
                [ticket.Id]: ticket,
              }),
              { ...state.entities },
            )
          : {};

      const totalOpenTickets = (data ?? []).filter((t) => !t.IsClosed).length;

      return {
        ...state,
        loading: false,
        loaded: true,
        entities,
        totalTickets: total,
        totalOpenTickets,
      };
    }

    case fromActions.LOAD_TICKETS_FAIL: {
      return {
        ...state,
        loading: false,
        loaded: false,
        totalTickets: 0,
      };
    }

    case fromActions.SET_SELECTED_TICKET: {
      const selectedTicketId = action.payload;

      return {
        ...state,
        selectedTicketId,
      };
    }

    case fromActions.CLEAR_TICKETS: {
      return {
        ...state,
        entities: {},
        totalTickets: 0,
        totalOpenTickets: 0,
      };
    }

    case fromActions.UPDATE_TICKET: {
      const ticket = action.payload;
      const entities = {
        ...state.entities,
        [ticket.Id]: ticket,
      };

      return {
        ...state,
        entities,
      };
    }

    default: {
      return state;
    }
  }
}

export const getTicketsEntities = (
  state: TicketState,
): { [id: string]: Ticket } => state.entities;
export const getTicketsLoading = (state: TicketState): boolean => state.loading;
export const getTicketsLoaded = (state: TicketState): boolean => state.loaded;
export const getTicketSelected = (state: TicketState): string =>
  state.selectedTicketId;
export const getTotalOpenTickets = (state: TicketState): number =>
  state.totalOpenTickets;
export const getTotalTickets = (state: TicketState): number =>
  state.totalTickets;
